import _sfc_main from "./ArrowStroke.vue2.mjs";
/* empty css                  */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: _setup.arrowStrokeClass }, [_c("div", { class: ["stroke-content", { "has-stroke": _vm.hasStroke }] }, [_c("div", { staticClass: "arrow-content", on: { "click": _setup.handleClickArrow } })]), _c(_setup.SvgIcon, { class: ["arrow", { "has-stroke": _vm.hasStroke }], on: { "click": _setup.handleClickArrow } }, [_c(_setup.ArrowStrokeLeftIcon, { class: _vm.arrowDirection })], 1)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "e586d337"
);
const ArrowStroke = __component__.exports;
export {
  ArrowStroke as default
};
